'use client';

import { SubjectsWidgetComponent } from './SubjectsWidgetComponent';

export function SubjectsWidgetComponentC(
  props: React.ComponentProps<typeof SubjectsWidgetComponent>,
) {
  return <SubjectsWidgetComponent {...props} />;
}
